import React, { PropsWithChildren } from 'react';

import { LoginBackgrounds } from '@identity/components';

export function AuthTemplate({ children }: PropsWithChildren) {
  return (
    <div className="auth-template">
      <div className="left-container">{children}</div>

      <div className="background-container">
        <LoginBackgrounds />
      </div>

      <style jsx>{`
        .auth-template {
          height: 100dvh;
          width: 100vw;
          display: flex;
        }

        .left-container {
          flex: 1 0 50%;
          height: 100%;
          display: flex;
          align-content: center;
          overflow: scroll;
          justify-content: center;
        }

        .background-container {
          flex: 1 0 50%;
          height: 100%;
        }

        @media (max-width: 991px) {
          .left-container {
            flex: 1 0 100%;
          }

          .background-container {
            display: none;
          }
        }
      `}</style>
    </div>
  );
}
